// extracted by css-extract-rspack-plugin
export default {"Description":"AttachmentErrorBanner-module__Description__rVkmk","MessageList":"AttachmentErrorBanner-module__MessageList__Q0ZWu"};